import styled from "@emotion/styled";

const TabsWrapper = styled.div``;

export default TabsWrapper;
